// Here's how you can create a shared utility that automatically sets meta: { requiresAuth: true } by default for all your apiSlice endpoints — unless you explicitly override it.
export function withDefaultMeta(
  endpointBuilder,
  defaultMeta = { requiresAuth: true }
) {
  return (config) => {
    const updatedConfig = {
      ...config,
      meta: {
        ...(defaultMeta || {}),
        ...(config.meta || {}), // Allow overrides
      },
    };
    return endpointBuilder(updatedConfig);
  };
}
